import type { PaletteRange } from '@mui/material/styles/createPalette';

// Professional Primary Colors - Modern, sophisticated, and trustworthy

export const professionalBlue = {
  50: '#f0f7ff',
  100: '#e0efff',
  200: '#b9ddff',
  300: '#7cc2ff',
  400: '#369eff',
  500: '#0c82f0',
  600: '#0066cc',
  700: '#0052a3',
  800: '#004785',
  900: '#003d6e',
  950: '#002449',
} satisfies PaletteRange;

export const corporateGray = {
  50: '#f8fafc',
  100: '#f1f5f9',
  200: '#e2e8f0',
  300: '#cbd5e1',
  400: '#94a3b8',
  500: '#64748b',
  600: '#475569',
  700: '#334155',
  800: '#1e293b',
  900: '#0f172a',
  950: '#020617',
} satisfies PaletteRange;

export const deepNavy = {
  50: '#f1f5f9',
  100: '#e2e8f0',
  200: '#cbd5e1',
  300: '#94a3b8',
  400: '#64748b',
  500: '#475569',
  600: '#334155',
  700: '#1e293b',
  800: '#0f172a',
  900: '#020617',
  950: '#010409',
} satisfies PaletteRange;

export const elegantTeal = {
  50: '#f0fdfa',
  100: '#ccfbf1',
  200: '#99f6e4',
  300: '#5eead4',
  400: '#2dd4bf',
  500: '#14b8a6',
  600: '#0d9488',
  700: '#0f766e',
  800: '#115e59',
  900: '#134e4a',
  950: '#042f2e',
} satisfies PaletteRange;

export const sophisticatedPurple = {
  50: '#faf5ff',
  100: '#f3e8ff',
  200: '#e9d5ff',
  300: '#d8b4fe',
  400: '#c084fc',
  500: '#a855f7',
  600: '#9333ea',
  700: '#7c3aed',
  800: '#6b21d8',
  900: '#581c87',
  950: '#3b0764',
} satisfies PaletteRange;

// Professional Supporting Colors

export const warmGray = {
  50: '#fafaf9',
  100: '#f5f5f4',
  200: '#e7e5e4',
  300: '#d6d3d1',
  400: '#a8a29e',
  500: '#78716c',
  600: '#57534e',
  700: '#44403c',
  800: '#292524',
  900: '#1c1917',
  950: '#0c0a09',
} satisfies PaletteRange;

export const professionalGreen = {
  50: '#f0fdf4',
  100: '#dcfce7',
  200: '#bbf7d0',
  300: '#86efac',
  400: '#4ade80',
  500: '#22c55e',
  600: '#16a34a',
  700: '#15803d',
  800: '#166534',
  900: '#14532d',
  950: '#052e16',
} satisfies PaletteRange;

export const professionalRed = {
  50: '#fef2f2',
  100: '#fee2e2',
  200: '#fecaca',
  300: '#fca5a5',
  400: '#f87171',
  500: '#ef4444',
  600: '#dc2626',
  700: '#b91c1c',
  800: '#991b1b',
  900: '#7f1d1d',
  950: '#450a0a',
} satisfies PaletteRange;

export const professionalAmber = {
  50: '#fffbeb',
  100: '#fef3c7',
  200: '#fde68a',
  300: '#fcd34d',
  400: '#fbbf24',
  500: '#f59e0b',
  600: '#d97706',
  700: '#b45309',
  800: '#92400e',
  900: '#78350f',
  950: '#451a03',
} satisfies PaletteRange;

// Neutral Colors - More sophisticated than default Material-UI

export const modernNeutral = {
  50: '#fcfcfd',
  100: '#f9fafb',
  200: '#f2f4f7',
  300: '#e4e7ec',
  400: '#d0d5dd',
  500: '#98a2b3',
  600: '#667085',
  700: '#475467',
  800: '#344054',
  900: '#1d2939',
  950: '#101828',
} satisfies PaletteRange;

export const coolGray = {
  50: '#f9fafb',
  100: '#f3f4f6',
  200: '#e5e7eb',
  300: '#d1d5db',
  400: '#9ca3af',
  500: '#6b7280',
  600: '#4b5563',
  700: '#374151',
  800: '#1f2937',
  900: '#111827',
  950: '#030712',
} satisfies PaletteRange;
